module.exports = __webpack_public_path__ + "static/media/chuyinshanadj.d6de3a39.webp";